<script>
    export default {
        name: 'modal',
        props: ['value'],
        data: function () {
            return {
                internalValue: null,
                localesLoaded: true,
                newLines: 1
            }
        },
        mounted: function(){

        },
        created: function() {
            this.internalValue = this.value;
        },
        methods: {
            close() {
                this.$emit('close');
            },
            validate(){
                this.$emit('validate');
            },
            addInventoryItem: function(){
                if( this.$store.state.scope.addresses.length <= 0 ){
                    alert("Aucune adresse connue")
                }else{
                    for(let i=0;i<this.newLines;i++){
                        this.internalValue.push({
                            location_id: this.$store.state.scope.addresses[0].id ? this.$store.state.scope.addresses[0].id : null,
                            internal_identifier: 'auto',
                            quantity: 1,
                            expiration_date: null
                        })
                    }
                }
            },
            removeInventoryItem: function(index){
                if( index == 0 && this.internalValue.length <= 1 ){
                    this.internalValue = [];
                }else{
                    this.internalValue.splice(index, 1)
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
            }
        }
    };
</script>
<template>
    <transition name="modal-fade" v-if="internalValue">
        <div class="modal-backdrop full">
            <div class="modal"
                 role="dialog"
                 aria-labelledby="modalTitle"
                 aria-describedby="modalDescription">
                <article>
                    <header
                            class="modal-header"
                            id="modalTitle">
                        <h1>Inventaire des articles</h1>

                        <div>
                            <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <div>
                        <div style="overflow: hidden; overflow-y: auto;" class="component-inventories">

                            <div v-if="internalValue">
                                <div class="header">
                                    <div></div>
                                    <div>Référence</div>
                                    <div>Quantity per sale</div>
                                    <div>Quantity</div>
                                    <div>Vendu</div>
                                    <div>Date d'expiration</div>
                                    <div>Localisation du stock</div>
                                    <div>Action</div>
                                </div>
                                <div v-for="(inventory, index) in internalValue" v-if="internalValue">
                                    <div>{{ index+1 }}</div>
                                    <div>
                                        <input type="text" v-model="inventory.internal_identifier"/>
                                    </div>
                                    <div>
                                        <input type="text" v-model="inventory.quantity_per_sale"/>
                                    </div>
                                    <div>
                                        <input type="text" v-model="inventory.quantity"/>
                                    </div>
                                    <div>{{ inventory.sales }}</div>
                                    <div>
                                        <input type="text" v-model="inventory.expiration_date"/>
                                    </div>
                                    <div>
                                        <select v-model="inventory.location_id">
                                            <option value="">Choisissez</option>
                                            <option v-for="location in $store.state.scope.addresses" v-bind:value="location.id">{{ location.company }}</option>
                                        </select>
                                    </div>
                                    <div>
                                        <button @click="removeInventoryItem(index)">Supprimer</button>
                                    </div>
                                </div>
                            </div>

                            <div style="float: right; margin-top: 5px;">
                                <button @click="addInventoryItem()"><span>Ajouter une référence</span></button>
                            </div>

                        </div>
                    </div>


                </article>
            </div>
        </div>
    </transition>
</template>


// WEBPACK FOOTER //
// src/components/form/EditorModal.vue